import React, { useEffect, useLayoutEffect } from "react";
import PullToRefresh from "react-simple-pull-to-refresh";
import { useParams, useNavigationType } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchDetailPageScroll,
  fetchVoucherInfo,
  updateVoucherInfoList,
} from "redux/slices/sales/salesSlice";

import { getDetailTitle } from "utils/define";
import { useManagerPaymentQuery } from "queries/Sales/useManagerPaymentQuery";
import { toReferenceDate, PERIOD_COUNT } from "pages/Sales/_lib/toReferenceDate";

import MainLayout from "layouts/MainLayout";
import SummaryInfo from "../period/SummaryInfo";
import DetailList from "./DetailList";
import PullToRefreshing from "components/common/PullToRefreshing";

/**
 * [이용권 종류별 매출]
 */

export const Detail = () => {
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const { seqPartnerBranch } = useParams();

  let { searchPartner, searchBranch, searchDate, searchPeriodType } =
    useSelector((state) => state.sales.voucherInfo);
  const partnerInfo = useSelector((state) => state.partner);
  const salesInfo = useSelector((state) => state.sales);

  const periodType = searchPeriodType || salesInfo.searchPeriodType || "daily";

  useEffect(() => {
    if (
      !searchPartner ||
      (navigationType != "POP" &&
        (searchPartner != partnerInfo.seqPartner ||
          searchBranch != partnerInfo.seqPartnerBranch ||
          searchPeriodType != salesInfo.searchPeriodType))
    ) {
      dispatch(
        fetchVoucherInfo({
          searchPartner: partnerInfo.seqPartner,
          searchBranch: Number(seqPartnerBranch) || partnerInfo.seqPartnerBranch,
          searchDate: salesInfo.searchDate,
          searchPeriodType: salesInfo.searchPeriodType,
        })
      );
    }
  }, []);

  useLayoutEffect(() => {
    return () => {
      dispatch(fetchDetailPageScroll("store"));
    };
  }, []);

  const query = useManagerPaymentQuery({
    seqPartner: searchPartner || partnerInfo.seqPartner,
    periodType,
    referenceDate: searchDate ? toReferenceDate(periodType, searchDate) : "",
    periodCount: PERIOD_COUNT[periodType],
    seqPartnerBranches: searchBranch ? [searchBranch] : undefined,
  });

  const data = query.data
    ? {
        totalAmount: query.data.totalAmount,
        serviceBreakdown: query.data.serviceBreakdown,
      }
    : undefined;

  const eventHandler = {
    changeDate: (date) => {
      dispatch(fetchVoucherInfo({ searchDate: date }));
    },
    pullToRefresh: () => {
      return new Promise((resolve) => {
        setTimeout(() => {
          query.refetch();
          dispatch(updateVoucherInfoList(false));
          resolve();
        }, 700);
      });
    },
  };

  const render = () => {
    const title = getDetailTitle(
      partnerInfo,
      searchPartner,
      searchBranch,
      "이용권 종류별 매출"
    );
    return (
      <PullToRefresh
        onRefresh={eventHandler.pullToRefresh}
        resistance={2}
        pullingContent={<></>}
        refreshingContent={<PullToRefreshing />}
      >
        <MainLayout
          withHeader={true}
          headerProps={{
            withBackButton: true,
            centerTitle: title,
          }}
          backgroundColor="white"
          withBottomTab={false}
        >
          <SummaryInfo
            mode={periodType}
            date={searchDate}
            data={data}
            isChart={false}
            isLoading={query.isLoading}
            isError={query.isError}
            onChange={eventHandler.changeDate}
            onRefresh={() => query.refetch()}
          />
          <DetailList />
        </MainLayout>
      </PullToRefresh>
    );
  };

  return render();
};

export default Detail;
